@if ((loading$ | async) === false) {
  @if (form$ | async; as formState) {
    <div class="grid">
      <div class="col-12">
        <p-card styleClass="very-compact-card p-3">
          <div class="formgrid grid">
            <div class="field col-12">
              <label class="font-medium required-field">Название</label>
              <crm-input-text
                [(value)]="form.name"
                class="w-full"
                [isError]="$any(errors?.name)"></crm-input-text>
              @if (errors?.name) {
                <small class="p-error">
                  {{ errors.name | join }}
                </small>
              }
            </div>
          </div>
        </p-card>

        <p-card
          styleClass="mt-3 very-compact-card p-3"
          header="Классификаторы">
          <h4 class="mt-0 mb-2">Доходы</h4>
          <div class="p-fluid">
            @for (classifier of form.incomeClassifiers; track $index) {
              <div class="field flex gap-2 align-items-center">
                <div class="p-inputgroup crm-hex-inputgroup flex-1 min-w-0">
                  <span class="p-inputgroup-addon white-space-nowrap">Доходы.</span>
                  <crm-input-text
                    class="w-full"
                    [(value)]="classifier.name"
                    placeholder="Название классификатора"></crm-input-text>
                </div>
                <crm-button
                  icon="pi pi-trash"
                  styleClass="p-button-danger p-button-text frm-form-control-icon-btn flex-shrink-0"
                  (onClick)="removeIncomeClassifier($index)"></crm-button>
              </div>
            }
          </div>
          <div class="flex justify-content-start mt-1">
            <crm-button
              icon="pi pi-plus"
              styleClass="p-button-success frm-form-control-icon-btn"
              (onClick)="addIncomeClassifier()"></crm-button>
          </div>

          <h4 class="mt-4 mb-2">Расходы</h4>
          <div class="p-fluid">
            @for (classifier of form.expenseClassifiers; track $index) {
              <div class="field flex gap-2 align-items-center">
                <div class="p-inputgroup crm-hex-inputgroup flex-1 min-w-0">
                  <span class="p-inputgroup-addon white-space-nowrap">Расходы.</span>
                  <crm-input-text
                    class="w-full"
                    [(value)]="classifier.name"
                    placeholder="Название классификатора"></crm-input-text>
                </div>
                <crm-button
                  icon="pi pi-trash"
                  styleClass="p-button-danger p-button-text frm-form-control-icon-btn flex-shrink-0"
                  (onClick)="removeExpenseClassifier($index)"></crm-button>
              </div>
            }
          </div>
          <div class="flex justify-content-start mt-1">
            <crm-button
              icon="pi pi-plus"
              styleClass="p-button-success frm-form-control-icon-btn"
              (onClick)="addExpenseClassifier()"></crm-button>
          </div>
        </p-card>
      </div>
    </div>

    @if (formState.canWrite) {
      <div class="mt-3">
        <div class="flex flex-wrap justify-content-between">
          <crm-button
            [label]="saveButtonLabel"
            styleClass="p-button-success"
            (onClick)="saveFormat()"></crm-button>

          @if (formState.isEdit) {
            <crm-button
              label="Удалить"
              styleClass="p-button-danger p-button-text"
              (onClick)="deleteFormat()"></crm-button>
          }
        </div>
      </div>
    }
  }
} @else {
  <crm-spinner></crm-spinner>
}
